import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Funder } from 'src/app/shared/models/funder';

@Component({
	selector: 'app-edit-funder-modal',
	templateUrl: './edit-funder-modal.component.html',
	styleUrls: ['./edit-funder-modal.component.scss']
})
export class EditFunderModalComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN),
			Validators.maxLength(32)
		])
	});

	funder: Funder;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	// labelIntervention: string;
	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.funder ? this.funder.name : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.funder.name = this.formEdit.get('name').value;
		this.facade.funderService.updateFunder(this.funder).subscribe((_succ) => {
			// this.isValidateButtonClicked=false;
			this.bsModalRef.hide();
		});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	get name() {
		return this.formEdit.get('name');
	}
}
